import intl from 'react-intl-universal';
import { FSelect } from '@/components/Forms';

/**
 * Resolves the localized label of an account type from its `key`
 * (e.g. `account_type.accounts-receivable`), falling back to the raw
 * English `label` returned by the backend when no translation exists.
 */
const localizeAccountType = (accountType: any) =>
  (accountType?.key && intl.get(`account_type.${accountType.key}`)) ||
  accountType?.label;

export function AccountsTypesSelect({ ...props }: any) {
  return (
    <FSelect
      valueAccessor={'key'}
      labelAccessor={localizeAccountType}
      textAccessor={localizeAccountType}
      placeholder={intl.get('select_account_type')}
      {...props}
    />
  );
}
